import React from 'react';
import { Link } from 'react-router-dom';

export function NotFound(): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-center p-8">
      <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
      <h2 className="text-2xl text-base-content/70 mb-2">Page Not Found</h2>
      <p className="text-base-content/50 mb-6">
        The page you are looking for does not exist.
      </p>
      <Link to="/" className="btn btn-primary gap-2">
        <span>&#8962;</span> Go Home
      </Link>
    </div>
  );
}
